
export default function About() {
  return (
    <section id="about" className="py-32 px-6 lg:px-20 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Image Column */}
          <div className="lg:col-span-2 relative">
            <div className="relative transform lg:rotate-3 transition-transform duration-500 hover:rotate-0">
              <div className="absolute -inset-4 bg-gradient-to-r from-cyan-400 to-red-500 rounded-lg opacity-75 blur-sm"></div>
              <div className="relative w-full h-[500px] rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/de46d687853cc06b12e42a359489c2ab.jpeg"
                  alt="Artist Portrait"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div className="lg:col-span-3 bg-zinc-900 p-12 lg:p-16 rounded-lg relative lg:-ml-20 z-10">
            <div className="mb-6">
              <span className="text-cyan-400 text-xs font-bold tracking-widest uppercase">About</span>
            </div>
            
            <h2 className="text-5xl lg:text-6xl font-bold text-white mb-8">THE STORY</h2>
            
            <div className="space-y-6 text-gray-300 text-base leading-relaxed">
              <p>
                Born and raised in Dallas Texas, Oak Cliff to be exact. His father was a preacher and he grew up in the church. Rapping since elementary school and always took a liking to Hip Hop, R&B, and Oldies.
              </p>
              
              <p>
                He signed to Deathrow Records in 1996 and made his debut on Tupac's "Gang Related" movie soundtrack under the name Tenkamenin. He was featured on two of J-Flexx's songs, which went multi platinum. He has also ghost wrote for many artists and still does.
              </p>
              
              <p>
                Heavy into helping the community and other artists achieve their goals. After Deathrow Records he signed to Tommy Boy Records. Then from Tommy Boy Records integrated to Team Dime Records. Then after that started his own label called Last Circle Entertainment. Soon after that he debuted "Witness Tha Realest" by RBC Records.
              </p>
              
              <div className="my-8 pl-6 border-l-4 border-red-500">
                <p className="text-2xl lg:text-3xl italic text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-red-500 font-light">
                  "Stay tapped in with Tha Realest!"
                </p>
              </div>
              
              <p>
                Currently he has been dropping single after single and working on a few film projects. He plans to continue helping up and coming artists along with organizing a tour coming to a city near you very soon.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-12 pt-12 border-t border-white/10">
              <div className="text-center">
                <div className="text-2xl font-bold text-white mb-2">500K+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Monthly Listeners</div>
              </div>
              <div className="text-center border-l border-r border-cyan-400/30">
                <div className="text-2xl font-bold text-white mb-2">50M+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Streams</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white mb-2">100+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Shows</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
